<template>
  <v-tooltip top>
    <template #activator="{ on }">
      <v-btn
        icon
        :color="activity.$.progress === 100 ? 'primary' : null"
        :disabled="activity.saving"
        @click.stop.prevent.native="toggleCompleted()"
        v-on="on"
      >
        <v-icon>
          {{ activity.$.progress === 100 ? 'check_circle' : 'check_circle_outline' }}
        </v-icon>
      </v-btn>
    </template>

    <span
      v-t="activity.$.progress === 100 ? 'activities.completed' : 'activities.markCompleted'"
    />
  </v-tooltip>
</template>

<script>
import Activity from '@/models/Activity'

export default {
  props: {
    activity: {
      type: Activity,
      default: () => new Activity()
    }
  },
  methods: {
    async toggleCompleted () {
      if (this.activity.progress === 100) {
        this.activity.progress = 0
      } else {
        this.activity.progress = 100
      }

      await this.activity.save()
      if (this.activity.$.progress === 100) {
        this.$emit('completed')
      }
    }
  }
}
</script>
